import initialState from '../../initialstate';
import * as types from '../../../actions/actiontypes';
import { clientRequestDocumentsTabIDs, documentTypes, HttpStatusCodes } from '../../../util/uiconstants';
import Utility from '../../../util/utilityfunctions';

export default function documentSettingConfigurationReducer(state = initialState.documentSettingConfiguration, action) {
    switch (action.type) {
        case 'DOCUMENT_GET_CONFIGURATION':
            return action.response;
    }

    return state;
}
